module.exports = __webpack_public_path__ + "static/media/carousal_1_desktop.d78fb64e.jpg";